import React from 'react'
import { Rating } from '@material-ui/lab'
import { useField } from 'formik'
import { makeStyles } from '@material-ui/core/styles'
import { AvenirDemi } from 'styles/variables'

const useStyles = makeStyles({
  ratingWithLabel: {
    margin: '15px 15px 15px 0',
    textAlign: 'left',
    width: '45%',
    minWidth: '150px',
    '& span': {
      fontFamily: AvenirDemi,
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap'
    }
  },
  ratingLabel: {
    lineHeight: 'inherit'
  }
})

export function RatingFieldComponent ({ name, label, disabled }) {
  const [, meta, helpers] = useField(name)
  const { value } = meta
  const { setValue } = helpers

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  return (
    <RatingWrapper label={label}>
        <Rating name={name} value={value} disabled={disabled}
                size={'large'}
                onChange={handleChange}
        />
    </RatingWrapper>
  )
}

export function ReadonlyRatingFieldComponent ({ value, label }) {
  return (
    <RatingWrapper label={label}>
        <Rating value={value}
                readOnly
                size={'large'}
        />
    </RatingWrapper>
  )
}

function RatingWrapper ({ label, children }) {
  const styles = useStyles()

  return (
    <div className={styles.ratingWithLabel}>
      <span>
        <h3 className={styles.ratingLabel}>{label}</h3>
        {children}
      </span>
    </div>
  )
}
